$(document).ready(function() {


	// * * * * * * * * * * * * * * * * * * * * * * * * *
	// * Name
	// *
	// *



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function(e){
        window.location = $(this).attr("href");
        return false;
    }).click(function(){
        window.location = $(this).find("a.js-click-item-link").attr("href");
        return false;
    });​




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page
    // *
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                scrollTo(target);
            return false;
            }
        }
    });

    function scrollTo(element) {
        $('html, body').animate({
            scrollTop: element.offset().top - 100
        }, 1000);
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * intro-slider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length){
        $heroSlider.slick({
            dots: true,
            arrows: false,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 8000,
            responsive: [
                {
                    breakpoint: 550,
                    settings: {
                        dots: false
                    }
                }
            ]
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * navMobile
	// *
	// *
	$('.js-nav-mobile-btn').click(function(){
		$('.js-nav-mobile').toggleClass('active');
		$('html, body').toggleClass('freeze');
	});

	$('.js-nav-mobile .parent span').click(function(){
		$(this).parents('li').toggleClass('is-open is-closed').find('ul').slideToggle();
	});

	// trigger active menü-parents
	$('.js-nav-mobile .parent.active span').trigger("click");



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * slider
    // *
    // *
    var $slider = $(".js-slider");

    if ($slider.length){
        $slider.slick({
            dots: false,
            arrows: true,
            prevArrow: $(".js-slider-nav-prev"),
            nextArrow: $(".js-slider-nav-next"),
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1300,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * Projekte fadeUp when in viewport by scroll
	// *
	// *
	var offset = 100; /* Abstand vom Browserbottom, wenn Effekt einsetzen soll */

	function fadeInElements(){
		var viewPort = $(window).scrollTop() + $(window).height();

		$(".js-fade-in-item:visible").each(function(){
			var elementTop = $(this).offset().top;

			if ((elementTop + offset) <= viewPort) {

				// check for countup - if in viepoint fire countUp (once)
				if ($(this).hasClass("js-countup") && !$(this).hasClass("fade-in-show")) {
					countup();
				}


				var delay = $(this).data("delay");
				$(this).css("animation-delay", delay + "s").addClass("fade-in-show");
			}
		});
	}
	$(window).scroll(function() {
		fadeInElements();
	});
	fadeInElements();



    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * countup
	// *
	// *
	function countup() {
		// count up
		var options = {
		  useEasing: true,
		  useGrouping: true,
		  separator: '.',
		  decimal: '.',
		};

		$(".js-countup-number").each(function(){
			var counterID = $(this).attr("id");
				countTo = $(this).data("count");
			var count = new CountUp(counterID, 0, countTo, 0, 4, options);
			count.start();
		});
	}



    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * telLink Sticky
	// *
	// *

    var $header = $(".header");
    var $headerH = $(".header").height();
	$(window).scroll(function() {
		if($(window).scrollTop() >= 1) {
            $header.addClass("sticky");
            $("body").css('padding-top', $headerH+'px');
		}else {
            $header.removeClass("sticky");
            $("body").css('padding-top','0');
		}
	});

});
